const GOOGLE_MAPS_OPTIONS = {
  id: 'google-maps-script',
  googleMapsApiKey: 'AIzaSyAgJGZluclPkhkxugfTXNvVgDVYJQ-7DVA', // Probably should store this in an ENV variable
  libraries: ['geocoding', 'places'],
  version: 'quarterly',
};

export default GOOGLE_MAPS_OPTIONS;
